"use strict";

APP.popups.EndPopup = function ( p_score, p_rating ) {

    // Invoke (needed)
    EHDI.aka.Container.call( this );

    // Properties

    // ** Parent (This reference)
    var _parent = this;

    // ** General Values
    var _score, _rating;

    // ** Graphics
    var _btnReturn, _btnRestart, _sprBG, _sprExplode, _sprOverlay, _sprStarsBG, _sprStars, _txtHeader, _txtScore, _txtHighscore, _timelineStars;

    // Private Methods

    // ** General Methods
    var _showStar = function ( p_target ) {

        p_target.visible = true;

        APP.managers.sound.playSFX( "star_gain" );
    };

    // ** Handlers
    var _handler_btnReturn = function () {

        // Stop bgm
        // APP.managers.sound.stopBGM();

        // Play button sfx
        APP.managers.sound.playSFX( "button_sfx", 0.7 );

        // Call SB
        // Main.SB.end( this.score );

        console.log("removing popup");
        // Remove popup
        APP.managers.scene.popPopUp( { y : new EHDI.scene.TransitionParameter( APP.config.stageHeight * 0.5, -APP.config.stageHeight ), duration : 0.25 } );

        // Change to next scene
        APP.managers.scene.changeScene( new APP.scenes.TitleScene(), { alpha : new EHDI.scene.TransitionParameter( 0, 1 ), duration : 0.25 } );
    };

    var _handler_btnRestart = function () {

        // Stop bgm
        // APP.managers.sound.stopBGM();

        // Play button sfx
        APP.managers.sound.playSFX( "button_sfx", 0.7 );

        // Call SB
        // Main.SB.end( this.score );

        console.log("removing popup");
        // Remove popup
        APP.managers.scene.popPopUp( { y : new EHDI.scene.TransitionParameter( APP.config.stageHeight * 0.5, -APP.config.stageHeight ), duration : 0.25 } );

        console.log("restarting");

        // Restart
        APP.scenes.GameScene.restart();

    };

    // ** Initialization Methods
    var _initProps = function ( p_score, p_rating ) {

        // Check if param values are invalid, then throw error
        if ( typeof p_score !== "number" ) throw "Score value for is not valid. Must be number.";
        if ( p_score < 0 ) throw "Score value for is not valid. Must be greater than or equal to zero.";

        if ( typeof p_rating !== "number" ) throw "Rating value for is not valid. Must be number.";
        if ( p_rating < 0 ) throw "Rating value for is not valid. Must be greater than or equal to zero.";

        // Intialize properties
        _score = p_score;
        _rating = p_rating;
    };

    var _initGraphics = function () {

        // Set parent position
        if ( _parent ) {

            _parent.x = APP.config.stageWidth * 0.5;
            _parent.y = APP.config.stageHeight * 0.5;
        }

        if ( !_sprOverlay ) {

            _sprOverlay =  EHDI.displays.FillRectangle( 0x000000, 0, 0, APP.config.stageWidth, APP.config.stageHeight, 0 );
            _sprOverlay.alpha = 0.5;
            _sprOverlay.anchor.set( 0.5, 0.5 );
            _sprOverlay.interactive = true;

            if ( _parent ) _parent.addChild( _sprOverlay );
        }

        if ( !_sprBG ) {

            _sprBG = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_pop.png" ] );
            _sprBG.anchor.set( 0.5, 0.5 );

            if ( _parent ) _parent.addChild( _sprBG );
        }

        if ( !_txtHeader ) {

            _txtHeader = new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_GAMEOVER"));
            _txtHeader.anchor.set( 0.5, 0.5 );

            _txtHeader.position.set( -_sprBG.width * 0.2, -_sprBG.width * 0.24 );
            _sprBG.addChild( _txtHeader );
        }

        if ( !_btnReturn ) {

            _btnReturn = new EHDI.displays.Button( EHDI.Assets.images[ "assets/ui/btn_exit.png" ],
                                                EHDI.Assets.images[ "assets/ui/btn_exit2.png" ], null, null);
            
            _btnReturn.position.set( -_sprBG.width * 0.15, _sprBG.height * 0.25 );
            _btnReturn.setOnClickFunction( _handler_btnReturn );

            _sprBG.addChild( _btnReturn );
        }

        if ( !_btnRestart ) {

            _btnRestart = new EHDI.displays.Button( EHDI.Assets.images[ "assets/ui/btn_replay.png" ],
                                                EHDI.Assets.images[ "assets/ui/btn_replay2.png" ], null, null); 
            _btnRestart.position.set( _sprBG.width * 0.15, _sprBG.height * 0.25 );
            _btnRestart.setOnClickFunction( _handler_btnRestart );

            _sprBG.addChild( _btnRestart );
        }


        if ( !_sprStarsBG ) {

            _sprStarsBG = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_starBG.png" ] );
            _sprStarsBG.anchor.set( 0.5, 0.5 );
            _sprStarsBG.position.set( 0, -_sprBG.height * 0.175 );
            _sprBG.addChild( _sprStarsBG );
        }

        if ( !_sprStars ) {

            _sprStars = [];

            for( var i = 0; i < 3; i++ ) {

                var sprStarBack = new EHDI.aka.Sprite(EHDI.Assets.images[ "assets/ui/gfx_star0.png" ]);
                sprStarBack.anchor.set( 0.5,0.5 );
                sprStarBack.position.set( _sprStarsBG.width * ( -0.15 + ( 0.15 * i ) ), 0 );
                _sprStarsBG.addChild( sprStarBack );

                var sprStarFront = new EHDI.aka.Sprite( EHDI.Assets.images[ "assets/ui/gfx_star1.png" ] );
                sprStarFront.anchor.set( 0.5, 0.5 );
                sprStarFront.scale.set( 1.2, 1.2 );

                _sprStars.push( sprStarFront );
                sprStarFront.visible = false;
                sprStarBack.addChild( sprStarFront );
            }
        }

        if ( !_txtScore ) {

            _txtScore = new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_SCORE"));
            _txtScore.text += _score.toString();
            _txtScore.anchor.set( 0.5, 0.5 );
            _txtScore.position.set( 0, _sprBG.height * 0.035 );
            _sprBG.addChild( _txtScore );
        }

        // if ( !_txtHighscore ) {

        //     _txtHighscore = new EHDI.displays.TextSprite(APP.managers.json.getLocale("STR_BESTSCORE"));
        //     // _txtHighscore.text += APP.save.highscore.toString();
        //     _txtHighscore.text += APP.SBData.highScore.toString();
        //     _txtHighscore.anchor.set( 0.5, 0.5 );
        //     _txtHighscore.position.set( 0, _sprBG.height * 0.15 );
        //     _sprBG.addChild( _txtHighscore );
        // }

        if ( !_sprExplode ) {

            _sprExplode = new EHDI.aka.Sprite(EHDI.Assets.images[ "assets/ui/gfx_explode.png" ] );
            _sprExplode.alpha = 0;
            _sprExplode.anchor.set( 0.5, 0.5 );
            _sprExplode.scale.set( 0.5, 0.5 );
            _sprStarsBG.addChild( _sprExplode );
        }

        if ( !_timelineStars ) {

            _timelineStars = new TimelineMax( { delay: 0.25 } );
            for ( var j = 0; j < _rating; j++ ) {

                _timelineStars.addCallback( _showStar, "+=0", [ _sprStars[ j ] ] );
                _timelineStars.to( _sprExplode, 0, { x : _sprStarsBG.width * ( -0.15 + ( 0.15 * j ) ), alpha : 1 }, "+=0.00001" );
                _timelineStars.to( _sprStars[ j ].scale, 0.5, { x : 1, y : 1 });
                _timelineStars.to( _sprExplode.scale, 0.6, { x : 1, y : 1 }, "-=0.5" );
                _timelineStars.to( _sprExplode, 0.6, { alpha : 0 }, "-=0.5" );
                _timelineStars.to( _sprExplode.scale, 0, { x : 0.5, y : 0.5 } );

            }

            _timelineStars.pause();
        }

    };

    var _initListeners = function () { };

    // ** Initialization Methods
    var _killProps = function () {

        _parent = null;

        _score = null;
        _rating = null;
    };

    var _killGraphics = function () {

        if ( _sprExplode ) {

            if ( _sprExplode.parent ) _sprExplode.parent.removeChild( _sprExplode );

            _sprExplode.destroy( { children: true } );
        }
        _sprExplode = null;

        if ( _sprStars ) {

            for ( var i = 0; i < _sprStars.length; i++ ) {

                var sprStar = _sprStars[ i ];

                if ( sprStar ) {

                    if ( sprStar.parent ) sprStar.parent.removeChild( sprStar );

                    sprStar.destroy( { children: true } );
                }

                _sprStars[ i ] = null;
            }
        }
        _sprStars = null;

        if ( _sprStarsBG ) {

            if ( _sprStarsBG.parent ) _sprStarsBG.parent.removeChild( _sprStarsBG );

            _sprStarsBG.destroy( { children: true } );
        }
        _sprStarsBG = null;

        if ( _btnReturn ) {

            _btnReturn.setOnClickFunction( null );
            if ( _btnReturn.parent ) _btnReturn.parent.removeChild( _btnReturn );

            _btnReturn.destroy( { children: true } );
        }
        _btnReturn = null;

        if ( _btnRestart ) {

            _btnRestart.setOnClickFunction( null );
            if ( _btnRestart.parent ) _btnRestart.parent.removeChild( _btnRestart );

            _btnRestart.destroy( { children: true } );
        }
        _btnRestart = null;

        if ( _txtScore ) {

            if ( _txtScore.parent ) _txtScore.parent.removeChild( _txtScore );

            _txtScore.destroy( { children: true } );
        }
        _txtScore = null;

        if ( _txtHighscore ) {

            if ( _txtHighscore.parent ) _txtHighscore.parent.removeChild( _txtHighscore );

            _txtHighscore.destroy( { children: true } );
        }
        _txtHighscore = null;

        if ( _sprBG ) {

            if ( _sprBG.parent ) _sprBG.parent.removeChild( _sprBG );

            _sprBG.destroy( { children: true } );
        }
        _sprBG = null;

        if ( _sprOverlay ) {

            if ( _sprOverlay.parent ) _sprOverlay.parent.removeChild( _sprOverlay );

            _sprOverlay.destroy( { children: true } );
        }
        _sprOverlay = null;

        if ( _timelineStars ) {

            _timelineStars.stop();
            _timelineStars.kill();
        }
        _timelineStars = null;

    };

    var _killListeners = function () { };

    // Public Methods

    // ** Popup Methods
    this.popUpWillAppear = function () { };

    this.popUpDidAppear = function () { if ( _timelineStars ) _timelineStars.play(); };
    // this.popUpDidAppear = function () { 
    //     var latestScore= _score;
    //     _sprBG.visible = false;
    //     location.href = "?score=" + latestScore;
    //     if ( _timelineStars ) _timelineStars.play(); 
        
    // };

    this.popUpWillDisappear = function () { if ( _sprOverlay ) _sprOverlay.alpha = 0; };

    this.popUpDidDisappear = function () { this.destroy( { children: true } ); };

    // ** Destroy
    this.destroy = function () {

        // Kill listeners
        _killListeners();

        // Kill graphics
        _killGraphics();

        // Kill props
        _killProps();

        // Call superclass method
        if(APP.popups.GameScene) APP.popups.GameScene.prototype.destroy.apply( this, arguments );
    };

    // Call init methods
    _initProps( p_score, p_rating );
    _initGraphics();
    _initListeners();

    Object.defineProperties( _parent, {
        "overlay": {
            get: function () { return _sprOverlay; },
            enumerable: true
        },
    });

    // Return parent
    return _parent;
}
APP.popups.EndPopup.prototype = Object.create( EHDI.aka.Container.prototype );
APP.popups.EndPopup.prototype.constructor = APP.popups.EndPopup;
